import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { dateConfigMap, fieldConfigDate, NgxConfigDate, supportedLanguageCodes } from '@frxjs/ngx-timeline';

@Pipe({
  name: 'dateTimeline', pure: false 
})
export class DateTimelinePipe implements PipeTransform {

  transform(date: Date | string, dateFormat?: string, langCode?: string): string {
    let transformedDate = null;
    if (date) {
      const objDate = this.getDateConfig(langCode);
      transformedDate = new DatePipe(objDate.code).transform(new Date(date), this.dateFormat(dateFormat, objDate));
    }
    return transformedDate;
  }

  private dateFormat(dateFormat: string, configDate: NgxConfigDate): string {
    return configDate[fieldConfigDate[dateFormat]];
  }

  private getDateConfig(langCode: string): NgxConfigDate {
    const code = langCode || supportedLanguageCodes[0];
    const configDate = dateConfigMap[code] || dateConfigMap[supportedLanguageCodes[0]];
    return configDate;
  }
}
